import React, { useEffect, useRef, useState } from "react";
import { Alert, Button, Card, Form, Spinner } from "react-bootstrap";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import axios from "axios";
import { Row, Col } from "react-bootstrap";
import ShimmerUI from "components/ShimmerUI/PatientShimmer";
import DatePicker from 'react-datepicker';
import moment from "moment";

const TransferForm = () => {
  const columns = [
    {
      accessorKey: "medication",
      header: "Medication",
      meta: {
        headerProps: {
          className: "text-start text-900",
        },
        cellProps: {
          className: "text-start",
        },
      },
    },
    {
      accessorKey: "strength",
      header: "Strength",
      meta: {
        headerProps: {
          className: "text-end text-900",
        },
        cellProps: {
          className: "text-end",
        },
      },
    },
    {
      accessorKey: "amount",
      header: "Amount",
      meta: {
        headerProps: {
          className: "text-end text-900",
        },
        cellProps: {
          className: "text-end",
        },
      },
    },
    {
      accessorKey: "frequency",
      header: "Frequency",
      meta: {
        headerProps: {
          className: "text-end text-900",
        },
        cellProps: {
          className: "text-end",
        },
      },
    },
    {
      accessorKey: "quantity",
      header: "Quantity",
      cell: ({ row }) => {
        const id = row.original.pharmacy_order_id;

        return (
          <Form.Control
            type="text"
            placeholder="0.0"
            className="text-end"
            defaultValue={quantityRef.current[id]}
            onChange={(e) => {
              quantityRef.current[id] = e.target.value;
            }}
          />
        );
      },
    },
  ];
  const [iframeSrc, setIframeSrc] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const quantityRef = useRef({});
  const [tableData, setTableData] = useState([]);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [staffName, setStaffName] = useState(localStorage.getItem("user-name") || '');
  const [date, setDate] = useState('');
  const [formData, setFormData] = useState({
    noOfDays: "",
  });
  const table = useAdvanceTable({
    data: tableData,
    columns,
    selection: false,
    sortable: true,
    pagination: true,
  });

  useEffect(() => {
    fetchData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const FinalPayload = {
      patient_id: localStorage.getItem("patientId"),
      // no_of_days: formData.noOfDays,
      from_location: from,
      to_location: to,
      staff_name: staffName,
      report_date : date ? moment(date).format("MM/DD/YY") : '',
      quantities: {},
    };
    Object.keys(quantityRef.current).forEach((id) => {
      FinalPayload.quantities[id] = quantityRef.current[id];
    });

    let tokenStr = localStorage.getItem("accessToken");
    let pelmedsMedSheetUrl = `${process.env.REACT_APP_SERVER_URL}/reports/transfer-form-report-exp`;
    try {
      const response = await axios.post(pelmedsMedSheetUrl, FinalPayload, {
        headers: { Authorization: `Bearer ${tokenStr}` },
      });
      if (!response.data.status) {
        setError(response.data.message);
      }
      const blob = new Blob([response.data], { type: "text/html" });
      const blobUrl = URL.createObjectURL(blob);
      setIframeSrc(blobUrl);
    } catch (err) {
      setError("Failed to print content.");
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    const tokenStr = localStorage.getItem("accessToken");
    let pelmedsMedSheetUrl =
      `${process.env.REACT_APP_SERVER_URL}` + "/reports/transfer-form";
    let frequencyMap = {};
    let amountMap = [];
    const getAllItems = {
      amount: {},
      frequency: {},
    };
    await axios
      .post(
        `${process.env.REACT_APP_SERVER_URL}/prescriptions/fetch-multiple`,
        getAllItems,
        { headers: { Authorization: `Bearer ${tokenStr}` } }
      )
      .then((res) => {
        let objFreqData = res.data.output.data["frequency"];
        let objAmountData = res.data.output.data["amount"];
        frequencyMap = objFreqData.reduce((acc, item) => {
          acc[item.id] = item.name;
          return acc;
        }, {});
        amountMap = objAmountData.reduce((acc, item) => {
          acc[item.id] = item.amount;
          return acc;
        }, {});
      });

    try {
      const { data } = await axios.post(
        pelmedsMedSheetUrl,
        { patient_id: localStorage.getItem("patientId") },
        { headers: { Authorization: `Bearer ${tokenStr}` } }
      );
      let results = [];
      data.validPrescriptions.forEach((item) => {
        const id = item.id;
        quantityRef.current[id] = item.no_of_pills?.toString() || "";

        results.push({
          pharmacy_order_id: id,
          medication: item.drug,
          strength: item.dose,
          amount: amountMap[item.amount_id],
          frequency: frequencyMap[item.frequency_id],
          quantity: quantityRef.current[id],
        });
      });
      setTableData(results);
    } catch (error) {
      React.toast.error("Error fetching data: " + error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
          height: 0,
          overflow: "hidden",
          width: 0,
        }}
      >
        {iframeSrc && (
          <iframe
            src={iframeSrc}
            style={{ width: "100%", height: "500px", border: "none" }}
            title="Preview Content"
          />
        )}
      </div>
      {isLoading ? (<ShimmerUI />)
        : tableData.length > 0 ? (
          <AdvanceTableProvider {...table}>
            <div className="h-100">
              <Form className="mb-3">
                <Row>
                  {/* <Col>
                  <Form.Label>No Of Days:</Form.Label>
                  <Form.Control
                    type="number"
                    name="noOfDays"
                    value={formData.noOfDays}
                    onChange={handleInputChange}
                    placeholder="Enter number of days"
                  />
                </Col> */}
                  <Col>
                    <Form.Label>From</Form.Label>
                    <Form.Control
                      type="text"
                      name="from"
                      value={from}
                      onChange={(e) => setFrom(e.target.value)}
                      placeholder="Enter from location"
                    />
                  </Col>
                  <Col>
                    <Form.Label>To</Form.Label>
                    <Form.Control
                      type="text"
                      name="to"
                      value={to}
                      onChange={(e) => setTo(e.target.value)}
                      placeholder="Enter to location"
                    />
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <Form.Label>Staff Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="staff_name"
                      value={staffName}
                      onChange={(e) => setStaffName(e.target.value)}
                      placeholder="Enter staff name"
                    />
                  </Col>
                  <Col>
                    <Form.Label>Date</Form.Label>
                    <DatePicker
                      placeholderText="mm/dd/yy"
                      selected={date}
                      onChange={date =>
                        setDate(date) 
                      }
                      dateFormat="MM/dd/yy"
                      className="form-control"
                    />
                  </Col>
                </Row>
              </Form>
              <div className="px-0 pt-0">
                <AdvanceTable
                  headerClassName="bg-200 text-nowrap align-middle"
                  rowClassName="align-middle white-space-nowrap"
                  tableProps={{
                    className: "fs-10 mb-0 overflow-hidden",
                  }}
                />
                <div className="text-end px-3 mt-3">
                  {!loading ? (
                    <Button
                      className="btn btn-primary btn-sm"
                      onClick={handleSave}
                    >
                      Generate
                    </Button>
                  ) : (
                    <Spinner animation="border" role="status" size="sm"></Spinner>
                  )}
                </div>
              </div>
            </div>
          </AdvanceTableProvider>
        ) : (
          <Alert variant="info" className="text-center fw-bold">
            No data found.
          </Alert>
        )}

    </>
  );
};

/*LoaFormGrid.propTypes = {
  tableData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      path: PropTypes.string.isRequired,
      views: PropTypes.number.isRequired,
      time: PropTypes.string.isRequired,
      exitRate: PropTypes.string.isRequired
    })
  ).isRequired,
  perPage: PropTypes.number
};*/

export default TransferForm;